var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFinland(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagFinland_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagFinland_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagFinland_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagFinland_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagFinland_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-7 44.114h70.487V2.998H-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F357E",
    d: "M12.832 2.999v14.769H-7.001v11.569h19.833v14.778H24.39V29.337h39.096V17.768H24.39V2.999z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iNDM2NmdwbWliYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJ4a2k2eHdvZjFiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzQzNjZncG1pYmEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiM0MzY2Z3BtaWJhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjeGtpNnh3b2YxYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0Y0RjRGNCIgZD0iTTAgNDEuMTE0TDcwLjQ4NyA0MS4xMTQgNzAuNDg3IC0wLjAwMiAwIC0wLjAwMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03IDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzFGMzU3RSIgZD0iTTE5LjgzMiAtMC4wMDFMMTkuODMyIDE0Ljc2OCAtMC4wMDEgMTQuNzY4IC0wLjAwMSAyNi4zMzcgMTkuODMyIDI2LjMzNyAxOS44MzIgNDEuMTE1IDMxLjM5IDQxLjExNSAzMS4zOSAyNi4zMzcgNzAuNDg2IDI2LjMzNyA3MC40ODYgMTQuNzY4IDMxLjM5IDE0Ljc2OCAzMS4zOSAtMC4wMDF6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAzKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlagFinland as ReactComponent };